import { usePDFPrintHook } from "@careinfo/layout";
import { tw } from "@careinfo/tailwind";
import moment from "moment";
//@ts-ignore
import { useSessionStorage } from "@uidotdev/usehooks";
import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import { IFilterExpenseNote } from "../../types/interface";
import APIS from "../../constant/Endpoint";
import DataTable from "../Reusable/Datatable";

const DailyNote = () => {
  const [localState, handleSetState] = useSessionStorage<IFilterExpenseNote>(
    "recieve-manifest-filter",
    {
      created__range: null,
      from_branch: null,
      ship_via: null,
    }
  );
  const { setValue, getValues, watch, reset, control } =
    useForm<IFilterExpenseNote>({
      defaultValues: async () => {
        return {
          created__range: localState?.created__range ?? null,
          from_branch: localState?.from_branch ?? null,
          ship_via: localState?.ship_via ?? null,
        };
      },
    });
  const navigate = useNavigate();
  let defaultColumns: any = [
    {
      header: "Created",
      accessorKey: "created",
      cell: ({ cell: { getValue } }) => {
        const value = getValue();
        if (!value) return <p>N/A</p>;

        const date = moment(value).format("YY-MM-DD");
        const time = moment(value).format("HH:mm:ss");

        return (
          <div className={tw`flex flex-col`}>
            <span className={tw`whitespace-nowrap`}>{date}</span>
            <span>{time}</span>
          </div>
        );
      },
    },
    {
      header: "Miti",
      accessorKey: "created_miti",
      cell: ({ cell: { getValue } }) => {
        const value = getValue();
        if (!value) return <p>N/A</p>;

        const date = moment(value).format("YY-MM-DD");

        return (
          <div className={tw`flex flex-col`}>
            <span className={tw`whitespace-nowrap`}>{date}</span>
          </div>
        );
      },
    },

    {
      header: "Total Items",
      accessorKey: "items",
      cell: ({ getValue }: any) => {
        const totalItems = getValue()?.length || 0;
        return (
          <>
            <p>{totalItems ?? "N/A"}</p>
          </>
        );
      },
    },
    {
      header: "In",
      accessorKey: "items",
      cell: ({ getValue }: any) => {
        const items = getValue() || [];
        const totalDebit = items.reduce((sum: number, item: any) => {
          return sum + Number(item.debit || 0);
        }, 0);
        return (
          <>
            <p> {totalDebit || "N/A"} </p>
          </>
        );
      },
    },
    {
      header: "Out",
      accessorKey: "items",
      cell: ({ getValue }: any) => {
        const items = getValue() || [];
        const totalCredit = items.reduce((sum: number, item: any) => {
          return sum + Number(item.credit || 0);
        }, 0);
        return (
          <>
            <p>{totalCredit ?? "N/A"}</p>
          </>
        );
      },
    },
    {
      header: "Balance",
      accessorKey: "items",
      cell: ({ getValue }: any) => {
        const items = getValue() || [];

        const totalDebit = items.reduce(
          (sum: number, item: any) => sum + Number(item.debit || 0),
          0
        );

        const totalCredit = items.reduce(
          (sum: number, item: any) => sum + Number(item.credit || 0),
          0
        );

        const balance = totalDebit - totalCredit;

        return <p>{balance || 0}</p>;
      },
    },
    {
      header: "Prepared By",
      accessorKey: "prepared_by.full_name",
      cell: ({ getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? "N/A"}</p>
          </>
        );
      },
    },
    {
      header: "Reviewed By",
      accessorKey: "reviewed_by.full_name",
      cell: ({ getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? "N/A"}</p>
          </>
        );
      },
    },
    {
      header: "Approved By",
      accessorKey: "approved_by.full_name",
      cell: ({ getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? "N/A"}</p>
          </>
        );
      },
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: ({ getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? "N/A"}</p>
          </>
        );
      },
    },
  ];

  const filterParams = watch();
  const handleNavigate = (row: any) => {
    navigate(`edit/${row.original?.id}`);
  };

  useEffect(() => {
    handleSetState({
      ...localState,
      ...filterParams,
    });
  }, [filterParams]);

  const params = useCallback(() => {
    const newValue = {};
    for (const [key, value] of Object.entries(filterParams)) {
      if (value) {
        if (Array.isArray(value)) {
          newValue[key] = value.map((v) => v.value).join(",");
        } else if (typeof value === "object") {
          newValue[key] = value.id;
        } else if (!value) {
          newValue[key] = null;
        } else {
          newValue[key] = value;
        }
      }
    }
    return newValue;
  }, [filterParams]);

  return (
    <>
      {/* <Card title="Filters" onClick={() => setFilterVisiable(!isFilterVisible)}>
        <Filter
          isFilterVisible={isFilterVisible}
          reset={handleFilterReset}
          control={control}
          setValue={setValue}
          getValues={getValues}
        />
      </Card> */}
      <DataTable
        url={APIS.DAILY_NOTE}
        queryKey={"daily-note"}
        columns={defaultColumns}
        onRowClick={handleNavigate}
        tableName="daily-note"
        addNew={{
          path: "create",
          label: "Add New",
        }}
        params={{
          ...params(),
        }}
      />
    </>
  );
};

export default DailyNote;

